module.exports = {
  STATUSES: [
    { caption: 'Приглашен', value: 'invited' },
    { caption: 'Резерв', value: 'reserve' },
    { caption: 'Думает', value: 'thinks' },
    { caption: 'Отказ', value: 'refusal' },
    { caption: 'Самоотказ', value: 'self_denial' },
    { caption: 'Перезвонить', value: 'call_back' },
    { caption: 'Не дозвон 1', value: 'ignores' },
    { caption: 'Не дозвон 2', value: 'ignores2' },
    { caption: 'Не дозвон 3', value: 'ignores3' },
    { caption: 'Спам', value: 'spam' },
    { caption: 'Отправлено смс', value: 'sms_sent' },
    { caption: 'Дубль', value: 'double' },
  ],
  REASONS_FOR_REFUSAL: [
    { caption: 'Возраст', value: 'age' },
    { caption: 'Нет Android', value: 'android' },
    { caption: 'Нет LMK', value: 'lmk' },
    { caption: 'Нет нужных документов', value: 'documents' },
    { caption: 'Не подходит график', value: 'schedule' },
    { caption: 'Уже нашёл работу', value: 'found_job' },
    { caption: 'Не подходит локация', value: 'location' },
    { caption: 'Не устраивает зарплата', value: 'salary' },
    { caption: 'Гражданство', value: 'citizenship' },
  ],
};
